import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { COMPLIANCE_STAFF_ROLES } from '@workspace/utils'
import { ComplianceFindingsPage } from '@/features/compliance-findings'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

const searchSchema = z.object({
  finding: z.string().optional(),
  status: z.string().optional(),
  audit: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
  // Phase 3 (I12): the hub's finding_action_overdue row links ?finding=&action=.
  action: z.string().optional(),
})

/**
 * Fix wave / A2 (ruling F2/F3): every `/compliance-findings*` API route is
 * gated by the tighter `requireComplianceStaffRead` (no `health_carer` /
 * `supported_employee`) — mirror that list here so a support worker is
 * bounced to /403 up front instead of landing on a page whose data all 403s.
 * Role-list reconciliation: shared via `@workspace/utils` — see hub.tsx's
 * comment for why this stopped being six independent hand-typed copies.
 */
export const Route = createFileRoute('/_authenticated/_organization/compliance/findings')({
  beforeLoad: async () => {
    await requireRoles([...COMPLIANCE_STAFF_ROLES])
    await requireActiveSubscription()
  },
  validateSearch: searchSchema,
  component: ComplianceFindingsPage,
})
